export default __webpack_public_path__ + "static/media/3-Swift.c142481f.png";